import { observable } from "mobx";
import { updateService } from "../_services";
import { IService } from "../_types/interfaces";
import i18n from 'i18next';

const translate = (name: string) => i18n.t('updates.notification.' + name);

export const updateStore = observable({
    loading: false,
    services: [] as IService[],
    isNotification: false,
    message: "",
    showMessage(message: string) {
        this.message = message;
        this.isNotification = true;
    },
    async loadServices() {
        this.loading = true;
        try {
            const response = await updateService.getServices();
            this.services = response.services;
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
    async downloadFiles(names: Array<string>) {
        this.loading = true;
        try {
            await updateService.updateServices({ 
                services: names.map(m => {return {name: m, action: "install"}})
            });
            this.showMessage(translate('download_ok'));
        }
        catch (error) {
            this.showMessage(translate('download_error'));
        }
        this.loading = false;
    },
    async sendRequest() {
        this.loading = true;
        try {
            await updateService.requestDownloadService();
            this.showMessage(translate('download_ok'));
        }
        catch (errors) {
            this.showMessage(translate('load_error'));
        }
        this.loading = false;
    },
});